import React from 'react';
import { motion } from 'framer-motion';
export function EmpathySection() {
  return <section className="py-12 md:py-20 px-4 md:px-6 relative overflow-hidden" style={{
    backgroundColor: 'var(--bg-surface)'
  }} data-id="element-126">
      <div className="max-w-[680px] mx-auto relative z-10" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6 md:space-y-8" data-id="element-128">
          <div className="space-y-4 md:space-y-6 text-lg md:text-xl text-[var(--text-primary)] leading-relaxed font-light" data-id="element-129">
            <p data-id="element-130">
              Te levantas a las 5 AM. Trabajas 12 horas. Pagas una renta de
              $2,500 por un lugar que nunca será tuyo.
            </p>
            <p data-id="element-131">
              Envías dinero, pero tus ahorros en el banco no crecen porque el
              costo de vida en USA se lo traga todo. 📉💸
            </p>

            <div className="bg-[var(--bg-card)] p-6 md:p-8 rounded-xl border border-[var(--accent)]/15 shadow-lg my-8" data-id="element-132">
              <p className="text-xl md:text-2xl font-serif text-[var(--text-heading)] text-center italic leading-snug" data-id="element-133">
                Te vendieron el "Sueño Americano", pero se siente como una
                condena de deuda eterna.
              </p>
            </div>

            <p data-id="element-134">
              Tienes ahorros, pero tienes miedo de que al salir de USA lo
              pierdas todo o te bloqueen las cuentas.
            </p>

            <div className="border-l-4 border-[var(--accent)] pl-5 py-2 mt-6" data-id="element-135">
              <p className="font-serif font-medium text-[var(--text-heading)] text-xl md:text-2xl" data-id="element-136">
                Sé exactamente cómo te sientes, y hay una salida real.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}